// extracted by mini-css-extract-plugin
var _1 = "GlNA0JEE";
var _2 = "Gbnwjlgp";
var _3 = "bgjn1Cji";
var _4 = "GlNA0JEE";
var _5 = "Gbnwjlgp";
var _6 = "bgjn1Cji";
var _7 = "xh40Tf_H";
var _8 = "PgJeM3OS no-print";
var _9 = "PgJeM3OS no-print";
export { _1 as "icon-delivery", _2 as "icon-stock", _3 as "icon-store", _4 as "iconDelivery", _5 as "iconStock", _6 as "iconStore", _7 as "large", _8 as "product-availability", _9 as "productAvailability" }
